var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('Logo',{attrs:{"onClick":_vm.onTitleClick}})],1),_c('b-col',{staticClass:"searchfield",attrs:{"md":"4"}},[_c('SearchField')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }